import templateUrl from 'emun.blog/blog-list.htm'
import controller from 'emun.blog/blog-list.controller'

let BlogList = {
    bindings: {
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default BlogList;